import { render, staticRenderFns } from "./narasumberLKU.vue?vue&type=template&id=7b3112ed"
import script from "./narasumberLKU.vue?vue&type=script&lang=js"
export * from "./narasumberLKU.vue?vue&type=script&lang=js"
import style0 from "./narasumberLKU.vue?vue&type=style&index=0&id=7b3112ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports